import Popover from "@mui/material/Popover/index.js";
import Stack from "@mui/material/Stack/index.js";
import { styled } from "@mui/material/styles";
const StyledFilterPopover = styled(Popover)(() => ({
  "& .MuiPaper-root": {
    width: "440px",
    borderRadius: "8px"
  }
}));
const FiltersContainer = styled(Stack)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  '&& .MuiSvgIcon-root[data-testid="CalendarIcon"]': {
    color: theme.palette.grey[800]
  }
}));
export {
  FiltersContainer,
  StyledFilterPopover
};
